<!--  -->
<div ngbDropdown [placement]="placement" (openChange)="onDropdownOpenCloseChange($event)" class="custom-class" display="dynamic" class="flex-center menu" [container]="container" [autoClose]="autoClose">
    <div ngbDropdownToggle (click)="onClickHeader()" class="menu-button"  (mouseenter)="mouseEnterPopup()"  (mouseleave)="mouseLeavePopup()">
        <ng-content select="[toggle]"> </ng-content>
    </div>
    <div ngbDropdownMenu class="menuContainer" [class]="customClass" (click)="stopPropagation($event)"  (mouseenter)="mouseEnterPopup()"  (mouseleave)="mouseLeavePopup()">
        <ng-content select="[body]"> </ng-content>
        <ng-content> </ng-content>
    </div>
</div>
